// extracted by mini-css-extract-plugin
export default {"customisation-bottom-bar-content":"CustomisationBottomBarContent_customisation-bottom-bar-content__5Kv35"};